import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              Hipobuy Sheet
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The ultimate resource center for product research, shopping guides, and spreadsheet tools. Helping shoppers make smarter decisions since 2024.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Categories
                </a>
              </li>
              <li>
                <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/shoes-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Shoes Guide
                </Link>
              </li>
              <li>
                <Link to="/hoodies-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Hoodies Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Main Platform
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Popular Categories
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Hoodies / Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  Jackets
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Safe Shopping Tips
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line text-accent-500 mt-0.5"></i>
                Always verify seller information
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line text-accent-500 mt-0.5"></i>
                Review QC photos carefully
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line text-accent-500 mt-0.5"></i>
                Use secure payment methods
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line text-accent-500 mt-0.5"></i>
                Check product details thoroughly
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet Guide. All rights reserved. This is an independent resource website.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
              Main Site
            </a>
            <Link to="/hipobuy-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
              Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}